<template>
  <v-container grid-list-md text-xs-center fluid>
    <h3 style="text-align: center">
      <v-icon
        style="margin-top: 10%; font-size: 128px"
        dark
        left
        class="primary--text"
        >warning</v-icon
      >
    </h3>
    <h2 style="text-align: center">We’ll be back soon!</h2>
    <h3 style="text-align: center">
      Sorry for the inconvenience. We’re performing some maintenance at the moment.
    </h3>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UnderMaintenance/UnderMaintenance.vue